module.exports = __webpack_public_path__ + "static/media/po_reports_1.1b0dfb8e.png";